import React from 'react';
import { Modal } from 'semantic-ui-react';
import Joyn2Button from '../../common/Joyn2Button';

const EngineRunCheckModal = (props) => {
  const { open, onYesClick, onNoClick } = props;
  return (
    <Modal size="mini" open={open}>
      <Modal.Header>Warning</Modal.Header>
      <Modal.Content>
        Running the engine again will discard the present engine result. Would you like to proceed?
      </Modal.Content>

      <Modal.Actions>
        <div style={{ display: 'flex', float: 'right', padding: '10px' }}>
          <Joyn2Button
            margin="0 10px 0 0"
            size="large"
            label="Yes"
            color="light"
            type="button"
            btnType="primary"
            onClick={onYesClick}
          />
          <Joyn2Button
            margin="0 10px 0 0"
            size="large"
            label="No"
            color="light"
            type="button"
            btnType="secondary"
            onClick={onNoClick}
          />
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default EngineRunCheckModal;
